﻿export interface IRecipientContactInformation {
    emailAddress: string,
    firstName: string,
    lastName: string,
    address: string,
    address2: string,
    city: string,
    state: string,
    postalCode: string,
    birthDate: string,
    phone: string,
}
